var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShoppingCart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.75c0-.414.333-.75.744-.75h2.975c.36 0 .67.261.732.62l.286 1.63h14.147a1.108 1.108 0 01.863.411 1.127 1.127 0 01.231.935l-1.338 6.75c-.051.255-.188.484-.387.65-.2.164-.45.254-.708.254H7.312l.262 1.5H18.85c.411 0 .744.336.744.75s-.333.75-.744.75H6.95a.746.746 0 01-.732-.62L4.095 4.5H1.744A.747.747 0 011 3.75zm6.05 9h11.19l1.19-6H6l1.05 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.694 18c-.822 0-1.488.672-1.488 1.5S6.872 21 7.694 21c.821 0 1.487-.672 1.487-1.5S8.515 18 7.694 18zM18.107 18c-.822 0-1.488.672-1.488 1.5s.666 1.5 1.488 1.5c.821 0 1.487-.672 1.487-1.5s-.666-1.5-1.488-1.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShoppingCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shopping-cart.f21bdbb92bafdc70cb2d1e6b727c911d.svg";